import { type RouteRecordRaw } from 'vue-router'
import { useAuthentificationStore, Utilisateur } from '@/features/auth'
import router from '@/router'

export const ROUTE_RESET_IMPERSO = 'reset-imperso'
export const PATH_RESET_IMPERSO = `/${ROUTE_RESET_IMPERSO}`
export const ROUTE_SET_IMPERSO = 'set-imperso'
export const PATH_SET_IMPERSO = `/${ROUTE_SET_IMPERSO}`

export const impersoRoutes: Array<RouteRecordRaw> = [
  {
    path: PATH_RESET_IMPERSO,
    name: ROUTE_RESET_IMPERSO,
    component: () => { },
    beforeEnter: async (to) => {
      const store = useAuthentificationStore()
      if (store.utilisateur instanceof Utilisateur === false) return false

      const nextPath = to.query.to as string | undefined
      store.deconnexionImpersonnalisationAsync().then(() => {
        return router.replace(nextPath ?? '/')
      }).catch(() => {
        return router.replace('/')
      })
      return false
    }
  }
]

